import _ from "lodash";
import ko from "knockout";
import keyCode from "util/keyCode";
import $ from "jquery";
import AudioPlayerView from "viewModels/widgets/audio/AudioPlayerView";
import qualityBroadcast from "services/qualityBroadcast";

import featureToggleService, {
    FeatureToggle,
} from "services/featureToggleService";

/**
 * <p>Binding for calculating the position within a scrubber control where click events occurs</p>
 * <p>This binding also calculates the final position of the position indicator control within the scrubber when it is dragged.</p>
 * <p>
 * This binding adds a click handler to elements that will calculate the
 * percentage-wise position that the event occurred within the scrubber control. Currently, along
 * it only calculates position on the x-axis and it is constrained to clicks or mouse drag
 * within the client area of the control.To utilize this binding handler, add
 * the following to your HTML tag's data-bind attribute:
 *
 *   data-bind="audioPlayerNavigation: { callbackRef: someEventCallback }"
 *
 * a properly formatted element might look like this
 *
 *   <div data-bind="audioPlayerNavigation: { callbackRef: handleAudioPlayerNavigation }">
 *   </div>
 *
 * Where handleAudioPlayerNavigation is a callback function on the ViewModel that your template is
 * referencing that accepts arguments of (percentPosition, event)
 *
 * # Optional Arguments
 * @param {string} [options.audioId='fga8cfc0-d3c4-47f5-9148-ac2c36f7b4d0'] a conversation id that
 *     sends callback information indicating if the scrubber is currently scrubbing
 *
 * Sample usage: audioPlayerNavigation: {
 *                   callbackRef: handleAudioPlayerNavigation,
 *                   audioId: audioId,
 *               }
 * </p>
 * @exports bindingHandlers/audioPlayerNavigation
 */
ko.bindingHandlers.audioPlayerNavigation = {
    init: function (element, valueAccessor) {
        const SCRUBBER_CLASS = "scrubber-position-indicator";
        const eventNameSpace = `${SCRUBBER_CLASS}-${_.uniqueId()}`;
        const DISPLACEMENT = 10;

        const audioId = ko.unwrap(valueAccessor().audioId) || undefined;
        const onScrubberNavigation = ko.unwrap(valueAccessor().callbackRef);

        const processDragPosition = function (
            x,
            target,
            event,
            panLeft,
            panRight
        ) {
            const $positionScrubber = $(event.currentTarget);
            const container = $(".playback-waveform");
            const scrubberWidth = $positionScrubber.width();
            const waveformWidth = target.width();
            const limitLeftPos = 0;
            const limitRightPos = waveformWidth - scrubberWidth;
            const limitLeftEdge = container.scrollLeft();
            const limitRightEdge =
                container.scrollLeft() + container.width() - scrubberWidth / 2;

            if (x < limitLeftPos) {
                x = limitLeftPos;
            }

            if (x > limitRightPos) {
                x = limitRightPos;
            }

            if (x < limitLeftEdge || panLeft) {
                x = limitLeftEdge;
            }

            if (x > limitRightEdge || panRight) {
                x = limitRightEdge;
            }

            const percentPosition = x / waveformWidth;
            if (percentPosition <= 100) {
                onScrubberNavigation(percentPosition, event);
            }
        };

        const processNewPosition = function (x, target, event) {
            if (x > 0 && x < target.width()) {
                const percentPosition = x / target.width();
                if (percentPosition <= 100) {
                    onScrubberNavigation(percentPosition, event);
                }
            }
        };

        const scrollIntoView = function () {
            //Use timeout to guarantee scrollIntoView fires after scrubber position updates.
            setTimeout(function () {
                const target = $(".playback-waveform");
                const scrollPosition = $(
                    ".waveform-playback-scrubber"
                ).position().left;
                target.animate({
                    scrollLeft: scrollPosition - target.width() / 2,
                });
            }, 0);
        };

        /**
         * Handles user key events
         */
        const handleKey = function (event) {
            let newDisplacement = 0;
            const trackbarPos = $(event.target).position().left;

            switch (event.which) {
                case keyCode.LEFT:
                    newDisplacement -= DISPLACEMENT;
                    break;
                case keyCode.RIGHT:
                    newDisplacement += DISPLACEMENT;
                    break;
                case keyCode.ENTER:
                    event.preventDefault();
                    return;
                default:
                    return;
            }

            const sliderPos = trackbarPos + newDisplacement;
            processNewPosition(sliderPos, $(element), event);
        };

        $(element).on(`click.${eventNameSpace}`, function (event) {
            const target = $(event.currentTarget);
            if (target) {
                const targetOffset = target.offset();
                if (
                    event.pageY > targetOffset.top &&
                    event.pageY < targetOffset.top + target.height()
                ) {
                    const x = event.pageX - targetOffset.left;
                    processNewPosition(x, target, event);
                }
            }
            return false;
        });

        const $positionScrubber = $(`.${SCRUBBER_CLASS}`, element.parentNode);
        let edgePanTimeout;
        let isEdgePanSet = false;

        $positionScrubber.on(`keydown.${eventNameSpace}`, handleKey);

        $positionScrubber.on(`click.${eventNameSpace}`, function (event) {
            event.preventDefault();
        });

        $positionScrubber.on(
            `mousedown.${eventNameSpace}`,
            function (mousedownEvent) {
                mousedownEvent.preventDefault();
                if (audioId) {
                    qualityBroadcast.publish(audioId, "isScrubbing", true);
                }

                $(document).on(`mousemove.${eventNameSpace}`, function (ev) {
                    const target = $(element);
                    const container = $(".playback-waveform");
                    if (target) {
                        const targetOffset = target.offset();
                        const x = ev.pageX - targetOffset.left;
                        processDragPosition(
                            x,
                            target,
                            mousedownEvent,
                            false,
                            false
                        );

                        const relativeScrubberPos = x - container.scrollLeft();
                        if (relativeScrubberPos >= container.width()) {
                            //initiate right edge pan
                            if (!isEdgePanSet) {
                                edgePanTimeout = setInterval(function () {
                                    const container = $(".playback-waveform");
                                    container.scrollLeft(
                                        container.scrollLeft() + 1
                                    );
                                    processDragPosition(
                                        x,
                                        target,
                                        mousedownEvent,
                                        false,
                                        true
                                    );
                                }, 10);
                                isEdgePanSet = true;
                            }
                        } else if (relativeScrubberPos <= 0) {
                            //initiate left edge pan
                            if (!isEdgePanSet) {
                                edgePanTimeout = setInterval(function () {
                                    const container = $(".playback-waveform");
                                    container.scrollLeft(
                                        container.scrollLeft() - 1
                                    );
                                    processDragPosition(
                                        x,
                                        target,
                                        mousedownEvent,
                                        true,
                                        false
                                    );
                                }, 10);
                                isEdgePanSet = true;
                            }
                        } else {
                            //disable edge pan
                            clearInterval(edgePanTimeout);
                            isEdgePanSet = false;
                        }
                    }
                });

                $(document).on(`mouseup.${eventNameSpace}`, function () {
                    scrollIntoView();
                    clearInterval(edgePanTimeout);
                    isEdgePanSet = false;
                    $(document).off(`mousemove.${eventNameSpace}`);
                    $(document).off(`mouseup.${eventNameSpace}`);
                    if (audioId) {
                        qualityBroadcast.publish(audioId, "isScrubbing", false);
                    }
                });
            }
        );

        $(element).on(`mouseup.${eventNameSpace}`, function () {
            scrollIntoView();
            clearInterval(edgePanTimeout);
        });

        // Clean up the binding handler when the element is removed from the DOM.
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            if (audioId) {
                qualityBroadcast.publish(audioId, "isScrubbing", false);
            }
            clearInterval(edgePanTimeout);
            $positionScrubber.off(`.${eventNameSpace}`);
            $(element).off(`.${eventNameSpace}`);
            $(document).off(`.${eventNameSpace}`);
        });
    },
};
